module.exports = __webpack_public_path__ + "img/ad_bg3.e4c66fd.png";